export default class Logger {
  public static error(error: Error): void {
    console.error(error);
  }
  public static warning(warning: string): void {
    console.warn(warning);
  }
}
